import { useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { activeCaseDocuments, deletedCaseDocuments } from "../../../../lib/docs"
import DropFilesHidden from "./DropFilesHidden"
import DocumentsTabListItem from "./DocumentsTabListItem"
import DocumentsTabListItemUploading from "./DocumentsTabListItemUploading"
import classes from './DocumentsTabListItem.module.css'

const DocumentsDetails = ({uploadedFile, removeFileWithId, deletePermission, restorePermission, hardDeletePermission}) => {
    const [activeData, setActiveData] = useState(null)
    const [deletedData, setDeletedData] = useState(null)
    const activeCase = useSelector(state => state.case.activeCase) 
    const searchedDocumentsResult = useSelector(state => state.files.filterResult)

    const [uploaded, setUploaded] = useState(uploadedFile)

    useEffect(() => {
        if (activeCase && Array.isArray(activeCase.documents)) {
            const sortByDate = (a, b) => new Date(b.created_at) - new Date(a.created_at)

            setActiveData(activeCaseDocuments(activeCase.documents).sort(sortByDate))
            setDeletedData(deletedCaseDocuments(activeCase.documents).sort(sortByDate))
        } else {
            setActiveData([])
            setDeletedData([])
        }

        setUploaded(uploadedFile)

    }, [activeCase, uploadedFile])


    return <div >
        <DropFilesHidden uploadfile={(val) => {setUploaded(val)}}>
            <div>
                <table>
                    <thead>
                        <tr>
                            <th>Document Name</th>
                            <th>Date Uploaded</th>
                            <th>Uploaded by</th>
                            {/* <th>Type</th> */}
                            <th>Document Type</th>                            
                            <th>Practice</th>
                            <th style={{width: 250}}>Notes</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(uploaded && uploaded.length > 0) && uploaded.map(item => (
                            <DocumentsTabListItemUploading key={item.id} data={item} file={item} removeFile={removeFileWithId}/>
                        ))}                                            

                        {!searchedDocumentsResult && activeData && activeData.map(item => (
                            <DocumentsTabListItem key={item.id} data={item} deletePermission={deletePermission} hardDeletePermission={hardDeletePermission}/>
                        ))}
                        {searchedDocumentsResult && searchedDocumentsResult.length > 0 && searchedDocumentsResult.map(item => (
                            <DocumentsTabListItem key={item.id} data={item} deletePermission={deletePermission} hardDeletePermission={hardDeletePermission}/>
                        ))}
                        {searchedDocumentsResult && searchedDocumentsResult.length == 0 && <tr>
                            <td colSpan="8">No results found!</td>
                        </tr>}

                        {!searchedDocumentsResult && deletedData && deletedData.length > 0 && (
                            <>
                                <tr className={classes.deleted_section_header}>
                                    <td colSpan="8">Deleted documents</td>
                                </tr>
                                {deletedData.map(item => (
                                    <DocumentsTabListItem key={`deleted-${item.id}`} data={item} isDeleted={true} restorePermission={restorePermission} hardDeletePermission={hardDeletePermission}/>
                                ))}
                            </>
                        )}
                    </tbody>
                </table>
            </div>
        </DropFilesHidden>
    </div>
}

export default DocumentsDetails